// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item {
  cursor: pointer;
  padding: 4px;
  margin: 2px 0;
  /* border-left: 2px solid #ddd; */

  label {
    margin-left: 8px;
    color: white;
  }
  span {
    color: white;
  }
}
.ml-4 {
  margin-left: 16px;
}

.menu-item:hover,
.menu-item.active {
  label {
    color: black;
  }
  span {
    color: black;
  }
}
.menu-item {
  font-size: 1rem;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s, color 0.3s;
  color: #8f9bb3;
  display: flex;
  align-items: center;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/contest-and-incentive-details/menu-incentive-item/menu-incentive-item.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iCAAiC;;EAEjC;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".menu-item {\n  cursor: pointer;\n  padding: 4px;\n  margin: 2px 0;\n  /* border-left: 2px solid #ddd; */\n\n  label {\n    margin-left: 8px;\n    color: white;\n  }\n  span {\n    color: white;\n  }\n}\n.ml-4 {\n  margin-left: 16px;\n}\n\n.menu-item:hover,\n.menu-item.active {\n  label {\n    color: black;\n  }\n  span {\n    color: black;\n  }\n}\n.menu-item {\n  font-size: 1rem;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.3s, color 0.3s;\n  color: #8f9bb3;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
